'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.fetchPopular = undefined;

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

exports.default = outfeat;

var _actionTypes = require('../actionTypes');

var _entities = require('./entities');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var initialState = {
  isLoading: false,
  outfeats: []
};

function outfeat() {
  var state = arguments.length <= 0 || arguments[0] === undefined ? initialState : arguments[0];
  var action = arguments.length <= 1 || arguments[1] === undefined ? {} : arguments[1];

  switch (action.type) {
    case _actionTypes.discoverActions.FETCH_POPULAR.STARTED:
      return (0, _extends3.default)({}, state, {
        isLoading: true
      });
    case _actionTypes.discoverActions.FETCH_POPULAR.COMPLETED:
      return (0, _extends3.default)({}, state, {
        isLoading: false,
        outfeats: action.result.result.outfeats
      });
    case _actionTypes.discoverActions.FETCH_POPULAR.FAILED:
      return (0, _extends3.default)({}, state, {
        isLoading: false,
        error: action.error
      });
    default:
      return state;
  }
}

var fetchPopular = exports.fetchPopular = function fetchPopular() {
  var all = arguments.length <= 0 || arguments[0] === undefined ? false : arguments[0];
  return {
    types: _actionTypes.discoverActions.FETCH_POPULAR.TYPES,
    promise: function promise(client) {
      return client.get('/discover/popular' + (all ? '?all=true' : '')).then(function (outfeats) {
        return (0, _entities.normalizer)('outfeats', outfeats);
      });
    }
  };
};


/*****************
 ** WEBPACK FOOTER
 ** ./src/redux/modules/discover.js
 ** module id = 458
 ** module chunks = 0
 **/